import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalWrapperComponent } from './modal-wrapper.component';
import { ModalModule } from '../modal/modal.module';



@NgModule({
  declarations: [
    ModalWrapperComponent
  ],
  imports: [
    CommonModule,
    ModalModule
  ],
  exports: [
    ModalWrapperComponent
  ]
})
export class ModalWrapperModule { }
